import { useCallback } from 'react';

import { Text } from '@simplywallst/ui-core';
import ChevronDownSmallSolid from '@simplywallst/ui-core/icons/ChevronDownSmallSolid';

import { Dropdown } from '@/components/Dropdown';

import type { ButtonRenderProps } from '@/components/Dropdown';

import type useFeedSorting from '../../hooks/useFeedSorting';

import { DropdownButton } from './styled';

interface Props {
  options: ReturnType<typeof useFeedSorting>['options'];
  handleSelect: ReturnType<typeof useFeedSorting>['handleSelect'];
  selectedSortType: ReturnType<typeof useFeedSorting>['selectedSortType'];
  disabled: boolean;
}

export const SortingDropdownButton = ({
  options,
  handleSelect,
  selectedSortType,
  disabled,
}: Props) => {
  const dropdownButton = useCallback(
    ({
      onBlur,
      onFocus,
      onClick,
      innerRef,
      value,
      name,
    }: ButtonRenderProps) => {
      return (
        <DropdownButton
          styleType="softLink"
          alignIcon="right"
          onBlur={onBlur}
          onFocus={onFocus}
          onClick={onClick}
          ref={innerRef}
          disabled={disabled}
          data-cy-id={name}
        >
          <Text as="span" typography="xSmall" color="whiteRGBA" opacity={0.5}>
            {value}
          </Text>
          <ChevronDownSmallSolid />
        </DropdownButton>
      );
    },
    [disabled]
  );
  return (
    <Dropdown
      name="feed-sorting"
      displayType="block"
      align="right"
      options={options}
      value={selectedSortType || 'newest'}
      onSelect={handleSelect}
      buttonRender={dropdownButton}
    />
  );
};
